import React from "react";
import SideBar from "../components/SideBar";
import Breadcrumbs from "../components/Breadcrumbs";
import UserIcon from "../components/UserIcon";
import Footer from "../components/Footer";
import EcommerceSettings from "../components/SettingsTabs/EcommerceSettings";

function EcommerceSettingsPage() {
  return (
    <div className="w-[96%] text-[17px] m-auto mt-6">
      <div className="m-auto mt-6 flex">
        <div>
          <SideBar />
        </div>
        <div className="w-full flex flex-col ml-6 text-[#033362] font-semibold">
          <div className="flex justify-between items-center w-full mb-3">
            <Breadcrumbs
              breads={[
                {
                  title: "Settings",
                  link: "/settings?tab=1",
                },
                {
                  title: "E-Commerce Controls",
                  link: "/ecommerce-settings",
                },
              ]}
            />
            <div className="flex items-center h-8">
              <UserIcon />
            </div>
          </div>

          <div className="bg-white grow rounded-2xl shadow-[0px_0px_16px_rgb(210,215,211)] border border-slate-100 overflow-hidden">
            <EcommerceSettings isStandalone={true} />
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default EcommerceSettingsPage;
